import * as t from 'io-ts';
import { createNonEmptyArrayFromArray } from 'io-ts-types/lib/fp-ts/createNonEmptyArrayFromArray';

const extractArrayHeadCodec = <C extends t.Mixed>(codec: C) => {
  const nonEmptyArrayT = createNonEmptyArrayFromArray(codec);
  return new t.Type<t.TypeOf<C>>(
    `ExtractArrayHeadCodec<${codec.name}>`,
    codec.is,
    (u, c) =>
      t
        .union([codec, nonEmptyArrayT])
        .validate(u, c)
        .map(x => (nonEmptyArrayT.is(x) ? x.head : x)),
    x => x
  );
};

export default extractArrayHeadCodec;
